import { TextField, useTheme } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

export function EditLeaderboardCell({
  id,
  value,
  field,
}: GridRenderEditCellParams) {
  const apiRef = useGridApiContext();
  const theme = useTheme();
  // eslint-disable-next-line @blumintinc/blumint/extract-global-constants
  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    apiRef.current.setEditCellValue({
      id,
      field,
      value: newValue,
    });
  };

  return (
    <TextField
      type="text"
      variant="standard"
      value={value}
      onChange={handleValueChange}
      sx={{
        height: '100%',
        '.MuiInputBase-root': {
          backgroundColor: `${theme.palette.background.light}`,
          boxShadow: 'none',
          outline: 'none',
          height: '100%',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.background.dark} !important`,
          borderWidth: 0,
        },
        ' & .MuiInput-underline:hover:before': {
          border: 'none !important',
        },
      }}
    />
  );
}
